var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wrapper",
      attrs: { id: "sideBarModalComponent" },
      on: { click: _vm.onClose },
    },
    [
      _c("div", { class: { wrapper_body: true, open: true } }, [
        _vm.loading
          ? _c(
              "div",
              [
                _c("pulse-loader", {
                  staticClass: "text-center pt-50vh",
                  attrs: { loading: true, color: _vm.loadingColor },
                }),
              ],
              1
            )
          : _c("div", [
              _vm.message
                ? _c("div", { staticClass: "pt-50vh" }, [
                    _vm._v("\n        " + _vm._s(_vm.message) + "\n      "),
                  ])
                : _c("div", { staticClass: "p-2" }, [
                    !_vm.records.length
                      ? _c("div", [
                          _c("h5", [_vm._v("Уведомлений не найдено")]),
                        ])
                      : _c(
                          "div",
                          _vm._l(_vm.records, function (record) {
                            return _c(
                              "div",
                              { key: record.id, staticClass: "record" },
                              [
                                _c("p", [
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-info pt-1" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          record.sub_object.title ||
                                            "не определен"
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex" }, [
                                  _c("span", [
                                    _vm._v("Входящий: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.moment(record.created_at))
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  record?.phone_call?.call_duration &&
                                  record.phone_call.call_duration > 0
                                    ? _c("div", { staticClass: "ml-1" }, [
                                        _c("span", {
                                          staticClass: "phone_call_sign",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              record.phone_call.call_duration
                                            ) +
                                            " сек.\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                record?.phone_call?.call_duration &&
                                record.phone_call.call_duration > 0
                                  ? [
                                      _c("PlayAudioByRequest", {
                                        attrs: { record: record.phone_call },
                                      }),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Клиент: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        record.sub_object?.client?.name ||
                                          "Не определен"
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.blackList["00" + record.sub_object.phoneNum]
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "pointer blacklist_block",
                                      },
                                      [
                                        _c(
                                          "BlackListButton",
                                          {
                                            attrs: {
                                              blackList:
                                                _vm.blackList[
                                                  "00" +
                                                    record.sub_object.phoneNum
                                                ],
                                            },
                                          },
                                          [
                                            _vm._t("default", function () {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-warning",
                                                  },
                                                  [_vm._v("черный список")]
                                                ),
                                              ]
                                            }),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c("span", { staticClass: "mr-1" }, [
                                      _vm._v("Номер телефона: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            record.sub_object.incomePhone ||
                                              record.sub_object.phoneNum
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("MakePhoneCall", {
                                      attrs: {
                                        className: "small",
                                        recordId: record.sub_object.record_id,
                                      },
                                    }),
                                    _vm._v(" "),
                                    record?.phone_call?.call_duration &&
                                    record.phone_call.call_duration > 0
                                      ? _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                record.phone_call.user?.name
                                              ) +
                                              "\n              "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("На номер: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        record.sub_object.toPhone ||
                                          record.sub_object.toPhoneNum
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.orderList[record.sub_object.phone_id]
                                  ? _vm._l(
                                      _vm.orderList[record.sub_object.phone_id],
                                      function (o) {
                                        return _c("p", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-success mr-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$AllProjects[o.site_id]
                                                    ?.title ?? o.site_id
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("strong", [_vm._v(_vm._s(o.id))]),
                                          _vm._v(
                                            "\n                (" +
                                              _vm._s(o.status_label) +
                                              ")\n                "
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-info newWindowBtn ml-1",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openOrderInModal(
                                                    o.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-eye",
                                              }),
                                            ]
                                          ),
                                        ])
                                      }
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex justify-content-between",
                                  },
                                  [
                                    _c("div", { staticClass: "flex" }, [
                                      (
                                        record?.phone_call?.client_requests ??
                                        []
                                      ).length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mr-1 flex align-items-center badge badge-info",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    record.phone_call
                                                      .client_requests.length
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-info btn-xs",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openClientRequest(
                                                record
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Сохранить запрос\n                  клиента\n                "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-success btn-xs",
                                        on: {
                                          click: () =>
                                            _vm.createOrder(record.sub_object),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Создать\n                заявку с\n                текущим\n                клиентом\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                  ]),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }